export const STEP_SUBMITTED_WITH_ERRORS = 'STEP_SUBMITTED_WITH_ERRORS';

export const APPRAISAL_EMAIL_STEP_SEND_EMAIL = 'APPRAISAL_EMAIL_STEP_SEND_EMAIL';
